<!-- eslint-disable no-console -->
<template>
  <FormContainer :type="2" :title="title">
    <Dashboard style="margin-top: 50px;" :percent="percent"/>
    <div class="title title-1">复赛第{{ data[1] === '2' ? '二' : '一' }}场（{{ info.time }}）</div>
    <div class="title title-2">{{ `${data[3]} ${data[2]} ${data[0]}` }}</div>
    <div class="title title-3">
      指针指向规则：得分越高则对应的排序越靠左，指针指向的值则越小。如果出现相同分数的考生，后续排序所占比例相应续延。
    </div>
  </FormContainer>
</template>
<script>
import FormContainer from './form-container.vue'
import Dashboard from '@/components/Dashboard.vue'
export default {
  components: {
    FormContainer,
    Dashboard
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    percent: 100
  }),
  watch: {
    data: {
      handler: function (val) {
        this.percent = +(val[5] || 0)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
  },
  mounted () {
    // this.percent = 80
    // setTimeout(() => {
    //   this.percent = 60
    // }, 3000)
  },
}
</script>
<style lang="less" scoped>
.title {
  text-align: center;
  width: 751px;
  margin: 0 auto;

  &-1 {
    color: #0152D0;
    font-size: 26px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-top: 36px;
  }

  &-2 {
    margin-top: 8px;
    color: #0152D0;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  &-3 {
    color: rgba(14, 30, 80, 0.5);
    font-size: 17px;
    line-height: 34px;
    font-weight: 400;
    margin-top: 32px;
  }

  .focus {
    color: #C31919;
    font-weight: 600;
  }

  .warning {
    color: #8516DD;
    font-weight: 600;
  }
}</style>